// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__M60XH","star":"Rating_star__2Gw+r","inner":"Rating_inner__8eHBP","empty":"Rating_empty__MzoF6","half":"Rating_half__geoXh"};